module.exports = __webpack_public_path__ + "img/quest_visualization_quest_pending_1.7eaec730.svg";